// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import type { ProductStateResponse } from "@bitebalance/contracts"
import type { BiteBalanceClient } from "@/api/client"

/**
 * GET /v1/product-state (ADR-048 / Budget Model v2): the backend-owned
 * truth state every budget surface reads. Resolves to null on ANY failure
 * — a surface that cannot read the truth renders nothing rather than a
 * guess (C-043, C-063). Wrapped in a promise so a synchronous throw (e.g.
 * a partial client) degrades the same way as a network error.
 */
export function fetchBudgetEconomics(
  api: Pick<BiteBalanceClient, "getProductState">
): Promise<ProductStateResponse["budgetEconomics"] | null> {
  return Promise.resolve()
    .then(() => api.getProductState())
    .then(res => res.budgetEconomics)
    .catch(() => null)
}
